// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2a-6";
export var headerCell = "_2a-2";
export var rowWrapper = "_2a-4";
export var stickyAggregationCell = "_2a-a";
export var stickyAggregationRow = "_2a-7";
export var stickyColumnCell = "_2a-9";
export var stickyColumnHeaderCell = "_2a-8";
export var table = "_2a-1";
export var virtualRowWrapper = "_2a-5";
export var virtualTableContainer = "_2a-0";
export var white = "_2a-3";